import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { ErrorService } from '@trustedshops/tswp-carrier-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserOnboardingInitService } from '../../services/user-onboarding-init.service';
import { ChatbotService } from '../../services/chatbot.service';
import {
  ViewTransitionDirection,
  ViewTransitionDirectionService
} from '../../services/view-transition-direction.service';

@Component({
  selector: 'presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('routeSlide', [
      transition('* <=> *', [
        query(':enter, :leave', [
          style({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          })
        ], { optional: true }),
        group([
          query(':enter', [
            style({
              opacity: 0,
              transform: '{{enterTransform}}'
            }),
            animate('180ms ease-out', style({
              opacity: 1,
              transform: 'translate3d(0, 0, 0)'
            }))
          ], { optional: true }),
          query(':leave', [
            style({
              opacity: 1,
              transform: 'translate3d(0, 0, 0)'
            }),
            animate('180ms ease-out', style({
              opacity: 0,
              transform: '{{leaveTransform}}'
            }))
          ], { optional: true })
        ])
      ], {
        params: {
          enterTransform: 'translate3d(0, 0, 0)',
          leaveTransform: 'translate3d(0, 0, 0)'
        }
      })
    ])
  ],
  standalone: false
})
export class PresentationComponent implements OnInit {
  public routeAnimationState$!: Observable<{ value: number; params: { enterTransform: string; leaveTransform: string } }>;

  public constructor(
    public readonly errorService: ErrorService,
    private readonly userOnboardingInitService: UserOnboardingInitService,
    private readonly chatbotService: ChatbotService,
    private readonly viewTransitionDirectionService: ViewTransitionDirectionService
  ) { }

  public ngOnInit(): void {
    this.userOnboardingInitService.init();
    this.chatbotService.init();

    this.routeAnimationState$ = this.viewTransitionDirectionService.state$
      .pipe(map((state) => ({
        value: state.sequence,
        params: this.mapDirectionToAnimationParams(state.direction)
      })));
  }

  private mapDirectionToAnimationParams(direction: ViewTransitionDirection): { enterTransform: string; leaveTransform: string } {
    switch (direction) {
      case 'up':
        return {
          enterTransform: 'translate3d(0, 16px, 0)',
          leaveTransform: 'translate3d(0, -16px, 0)'
        };
      case 'down':
        return {
          enterTransform: 'translate3d(0, -16px, 0)',
          leaveTransform: 'translate3d(0, 16px, 0)'
        };
      case 'left':
        return {
          enterTransform: 'translate3d(16px, 0, 0)',
          leaveTransform: 'translate3d(-16px, 0, 0)'
        };
      case 'right':
        return {
          enterTransform: 'translate3d(-16px, 0, 0)',
          leaveTransform: 'translate3d(16px, 0, 0)'
        };
      default:
        return {
          enterTransform: 'translate3d(0, 0, 0)',
          leaveTransform: 'translate3d(0, 0, 0)'
        };
    }
  }
}
